import React from 'react';

export default {
  convertPastedFiledToAttachments(
    e: React.ClipboardEvent<HTMLDivElement>
  ): File[] {
    const items = e.clipboardData?.items;

    return (
      Array.from(items)
        .filter((item) => item.kind === 'file')
        .map((item) => item.getAsFile()) ?? []
    );
  },
};
